import { ChangeEvent, useState } from 'react'
import BrandedLogo from '../components/branded-logo'
import CustomInput from '../components/customs/custom-input'
import CustomButton from '../components/customs/custom-button'
import Loader from '../components/loader'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/ParseErrors'
import axiosInstance from '../utils/axiosInstance'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ResetPassword = () => {
    const navigation = useNavigate()
    const [values, setValues] = useState<any>({
        password: "",
        cpassword: "",
    })
    const [loading, setIsLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const ref_id = searchParams.get("ref_id")

    // ------------------------------- [ HANDLE LOGIN ] -------------------------------
    const HandleResetPassword = async () => {
        if (Validate()) {
            setIsLoading(true)
            try {
                await axiosInstance.put(`/auth/reset-password/${ref_id}`, values)
                toast.success("Password Updated successfully")
                setIsLoading(false)
                navigation("/auth")
            } catch (error) {
                toast.error(ParseErrors(error))
                setIsLoading(false)
            }
        }
    }

    // ---------------------- [  VALIDATION FUNCTION ] ----------------------

    const Validate = () => {
        if (!values.password) {
            toast.error("Please enter a password")
            return false
        } else if (!values.cpassword) {
            toast.error("Please confirm your password")
            return false
        } else if (values.cpassword !== values.password) {
            toast.error("Password and Confirm Password must be same")
            return false
        } else {
            return true
        }
    }


    // ---------------------- [  ON INPUT CHANGE SET VALUES ] ----------------------
    const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const RedirectToLogin = () => {
        navigation("/auth")
    }

    return (
        <div className='w-[100%] h-[100vh] bg-background flex flex-col lg:flex-row items-center justify-between overflow-y-auto overflow-x-hidden'>
            {/* AUTH PAGE LOGO */}
            <div className="w-[100%] lg:w-[45%] h-[100%] flex items-center justify-center relative z-10" >
                <div className='h-[200px] w-[450px] lg:h-[400px] blur-3xl rounded-[50%] bg-indigo-600/20 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] animate-pulse'></div>
                <div className=" p-[30px] text-center border-r-[50%] relative animate-fade-in-slow">
                    <p className="text-[35px] lg:text-[55px]">👋</p>
                    <h4 className="text-text-secondary text-[22px] lg:text-[28px] font-medium">Welcome to</h4>
                    <BrandedLogo className="w-[200px] lg:w-[300px] mt-2 h-[auto] object-cover" alt="" />
                </div>
            </div>
            {/* AUTH PAGE LOGO */}


            {/* LOGIN AND RESET FORM */}


            <div className='w-[100%] lg:w-[55%] h-full flex items-center justify-center'>
                <div className={`w-[90%] lg:w-[55%] max-w-[430px] h-[480px] relative [perspective:1000px] `}>
                    <div className={`h-full w-full relative transition-all duration-500`}>

                        {/*------------------------------- LOGIN FORM --------------------- */}
                        <div className={`absolute inset-0 py-[30px] sm:py-[40px] px-[25px] sm:px-[50px] bg-surface border border-edge rounded-2xl shadow-overlay`}>
                            <div >
                                <h2 className="text-center text-[26px] bg-gradient-to-r from-blue to-accent-bright bg-clip-text text-transparent font-heading-font">RESET PASSWORD</h2>
                                <div className=' my-8'>
                                    <CustomInput title="Password" label='Password' name='password' type='password' onChange={onChangeValues} className='border-[1px] border-[#DEE4EB]' />
                                    <div className='my-6'></div>
                                    <CustomInput title="Confirm Password" label='Confirm Password' name='cpassword' type='password' onChange={onChangeValues} className='border-[1px] border-[#DEE4EB]' />

                                    <CustomButton variant="primary" className='w-full mt-[55px] !text-base' onClick={HandleResetPassword}>{loading ? <Loader /> : "SUBMIT"}</CustomButton>
                                    <p className='text-base text-blue font-medium cursor-pointer mt-6 text-center hover:text-indigo-300 transition-colors' onClick={RedirectToLogin}>Back to Login?</p>
                                </div>
                            </div>
                        </div>
                        {/*------------------------------- LOGIN FORM --------------------- */}



                    </div>
                </div>
            </div>




            {/* LOGIN AND RESET FORM */}
        </div>
    )
}

export default ResetPassword
